import { Charts } from './Charts';
import PoliceChartsDataProvider from './contexts/PoliceChartsDataContext';

const PoliceWrapper = () => {
    return (
        <PoliceChartsDataProvider>
            <Charts />
        </PoliceChartsDataProvider>
    );
};

export default PoliceWrapper;
